module.exports = __webpack_public_path__ + "static/img/product_images_08_h5_zh.e5f337b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_08_h5_zh.png
// module id = gYBI
// module chunks = 34